/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { isBoolean } from "utils/lodashUtils";

class TopPanelStore {
  @observable showTopPanel;
  @observable topPanelVerbId;
  @observable isTopPanelExpaned;

  topPanelOptions = {};

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.topPanelVerbId = null;
    this.showTopPanel = false;
    this.isTopPanelExpaned = false;
  }

  @action.bound
  setTopPanelVisibility(value) {
    this.showTopPanel = value;
  }

  @action
  registerTopPanelVerbId(verbId, opts = {}) {
    this.topPanelVerbId = verbId;
    this.topPanelOptions = opts;
    if (isBoolean(opts.visibility)) this.setTopPanelVisibility(opts.visibility);
    if (isBoolean(opts.expanded)) this.setTopPanelExpandedState(opts.expanded);
  }

  @action.bound
  setTopPanelExpandedState(value) {
    this.isTopPanelExpaned = value;
  }
}

export { TopPanelStore };
